import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { spacer } from '../../themes/foundations/spacer';
export var fontSize = {
    h1: '60px',
    h2: '48px',
    h3: '36px',
    h4: '30px',
    h5: '24px',
    h6: '20px'
};
export var lineHeight = {
    h1: '1.2',
    h2: '1.16666667',
    h3: '1.22222222',
    h4: '1.33333333',
    h5: '1.5',
    h6: '1.4'
};
export var fontWeight = {
    h1: '700',
    h2: '700',
    h3: '700',
    h4: '700',
    h5: '700',
    h6: '700',
    span: 'normal',
    p: 'normal',
    a: 'normal',
    del: 'normal',
    sup: 'normal',
    sub: 'normal'
};
var fontFamily = {
    h1: 'typographyHeading',
    h2: 'typographyHeading',
    h3: 'typographyHeading',
    h4: 'typographyHeading',
    h5: 'typographyHeading',
    h6: 'typographyHeading',
    span: 'typographyBody',
    p: 'typographyBody',
    a: 'typographyBody',
    del: 'typographyBody',
    sup: 'typographyBody',
    sub: 'typographyBody'
};
export var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  display: ", ";\n  ", "\n\n  // Large screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n\n  // Medium screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n\n  // Small screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n\n  // Extra Small screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n"], ["\n  box-sizing: border-box;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  display: ", ";\n  ", "\n\n  // Large screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n\n  // Medium screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n\n  // Small screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n\n  // Extra Small screen\n  @media screen and (max-width: ", ") {\n    ", "\n  }\n"])), function (props) { return props.theme.tokens[fontFamily[props.as]] || props.font || 'inherit'; }, function (props) { return props.weight || fontWeight[props.as] || 'normal'; }, function (props) {
    var _a, _b, _c, _d;
    return typeof props.size === 'object'
        ? fontSize[((_a = props.size) === null || _a === void 0 ? void 0 : _a['xl']) || ((_b = props.size) === null || _b === void 0 ? void 0 : _b[0]) || props.as] || ((_c = props.size) === null || _c === void 0 ? void 0 : _c[0]) || ((_d = props.size) === null || _d === void 0 ? void 0 : _d['xl'])
        : fontSize[props.size || props.as] || props.size;
}, function (props) {
    var _a, _b;
    if (props.margin) {
        return "margin: ".concat(typeof props.margin === 'object'
            ? ((_a = props.margin) === null || _a === void 0 ? void 0 : _a['xl']) || ((_b = props.margin) === null || _b === void 0 ? void 0 : _b[0])
            : spacer[props.margin] || props.margin || '0', ";");
    }
}, function (props) {
    if (props.mt) {
        return "margin-top: ".concat(spacer[props.mt] || props.mt || '0', ";");
    }
}, function (props) {
    if (props.mr) {
        return "margin-right: ".concat(spacer[props.mr] || props.mr || '0', ";");
    }
}, function (props) {
    if (props.mb) {
        return "margin-bottom: ".concat(spacer[props.mb] || props.mb || '0', ";");
    }
}, function (props) {
    if (props.ml) {
        return "margin-left: ".concat(spacer[props.ml] || props.ml || '0', ";");
    }
}, function (props) {
    var _a, _b;
    if (props.padding) {
        return "padding: ".concat(typeof props.padding === 'object'
            ? ((_a = props.padding) === null || _a === void 0 ? void 0 : _a['xl']) || ((_b = props.padding) === null || _b === void 0 ? void 0 : _b[0])
            : spacer[props.padding] || props.padding || '0', ";");
    }
}, function (props) {
    if (props.pt) {
        return "padding-top: ".concat(spacer[props.pt] || props.pt || '0', ";");
    }
}, function (props) {
    if (props.pr) {
        return "padding-right: ".concat(spacer[props.pr] || props.pr || '0', ";");
    }
}, function (props) {
    if (props.pb) {
        return "padding-bottom: ".concat(spacer[props.pb] || props.pb || '0', ";");
    }
}, function (props) {
    if (props.pl) {
        return "padding-left: ".concat(spacer[props.pl] || props.pl || '0', ";");
    }
}, function (props) { return lineHeight[props.as] || props.height; }, function (props) { return props.theme.tokens[props.color] || props.color || 'initial'; }, function (props) { return props.theme.tokens[props.background] || props.background || 'initial'; }, function (props) { return (props.block ? 'block !important' : 'revert'); }, function (props) {
    if (props.block) {
        return "width: 100%;";
    }
}, function (props) { return props.theme.tokens.mediaScreenLG; }, function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof props.size === 'object') {
        return "font-size: ".concat(fontSize[((_a = props.size) === null || _a === void 0 ? void 0 : _a['lg']) || ((_b = props.size) === null || _b === void 0 ? void 0 : _b[1])] || ((_c = props.size) === null || _c === void 0 ? void 0 : _c['lg']) || ((_d = props.size) === null || _d === void 0 ? void 0 : _d[1]), ";");
    }
    if (typeof props.margin === 'object') {
        return "margin: ".concat(((_e = props.margin) === null || _e === void 0 ? void 0 : _e['lg']) || ((_f = props.margin) === null || _f === void 0 ? void 0 : _f[1]), ";");
    }
    if (typeof props.padding === 'object') {
        return "padding: ".concat(((_g = props.padding) === null || _g === void 0 ? void 0 : _g['lg']) || ((_h = props.padding) === null || _h === void 0 ? void 0 : _h[1]), ";");
    }
}, function (props) { return props.theme.tokens.mediaScreenMD; }, function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof props.size === 'object') {
        return "font-size: ".concat(fontSize[((_a = props.size) === null || _a === void 0 ? void 0 : _a['md']) || ((_b = props.size) === null || _b === void 0 ? void 0 : _b[2])] || ((_c = props.size) === null || _c === void 0 ? void 0 : _c['md']) || ((_d = props.size) === null || _d === void 0 ? void 0 : _d[2]), ";");
    }
    if (typeof props.margin === 'object') {
        return "margin: ".concat(((_e = props.margin) === null || _e === void 0 ? void 0 : _e['md']) || ((_f = props.margin) === null || _f === void 0 ? void 0 : _f[2]), ";");
    }
    if (typeof props.padding === 'object') {
        return "padding: ".concat(((_g = props.padding) === null || _g === void 0 ? void 0 : _g['md']) || ((_h = props.padding) === null || _h === void 0 ? void 0 : _h[2]), ";");
    }
}, function (props) { return props.theme.tokens.mediaScreenSM; }, function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof props.size === 'object') {
        return "font-size: ".concat(fontSize[((_a = props.size) === null || _a === void 0 ? void 0 : _a['sm']) || ((_b = props.size) === null || _b === void 0 ? void 0 : _b[3])] || ((_c = props.size) === null || _c === void 0 ? void 0 : _c['sm']) || ((_d = props.size) === null || _d === void 0 ? void 0 : _d[3]), ";");
    }
    if (typeof props.margin === 'object') {
        return "margin: ".concat(((_e = props.margin) === null || _e === void 0 ? void 0 : _e['sm']) || ((_f = props.margin) === null || _f === void 0 ? void 0 : _f[3]), ";");
    }
    if (typeof props.padding === 'object') {
        return "padding: ".concat(((_g = props.padding) === null || _g === void 0 ? void 0 : _g['sm']) || ((_h = props.padding) === null || _h === void 0 ? void 0 : _h[3]), ";");
    }
}, function (props) { return props.theme.tokens.mediaScreenXS; }, function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof props.size === 'object') {
        return "font-size: ".concat(fontSize[((_a = props.size) === null || _a === void 0 ? void 0 : _a['xl']) || ((_b = props.size) === null || _b === void 0 ? void 0 : _b[4])] || ((_c = props.size) === null || _c === void 0 ? void 0 : _c['xl']) || ((_d = props.size) === null || _d === void 0 ? void 0 : _d[4]), ";");
    }
    if (typeof props.margin === 'object') {
        return "margin: ".concat(((_e = props.margin) === null || _e === void 0 ? void 0 : _e['xs']) || ((_f = props.margin) === null || _f === void 0 ? void 0 : _f[4]), ";");
    }
    if (typeof props.padding === 'object') {
        return "padding: ".concat(((_g = props.padding) === null || _g === void 0 ? void 0 : _g['xs']) || ((_h = props.padding) === null || _h === void 0 ? void 0 : _h[4]), ";");
    }
});
var templateObject_1;
